import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ReportService } from '../report.service';
import { RteDialogRef, RTEAlertService } from 'rte-library';
import { SaveStep } from '../models/save-step.model';
import { StepStatusEnum } from 'src/app/reports/enums/step-status.enum';
import { Report } from '../models/report.model';
import { UserPermissionReportService } from 'src/app/service/userPermissionReportService';
import { UserPermissionReport } from 'src/app/models/userPermissionReport';
import { MenuService } from 'src/app/service/menu.service';
import { ObjectReportService } from 'src/app/service/object-report.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-report-save-dialog',
  templateUrl: './report-save-dialog.component.html',
  styleUrls: ['./report-save-dialog.component.scss']
})
export class ReportSaveDialogComponent implements OnInit {

  constructor(public dialogRef: RteDialogRef<ReportSaveDialogComponent>,
    public reportService: ReportService,
    public userPermissionReportService: UserPermissionReportService,
    public menuService: MenuService,
    public objectService: ObjectReportService,
    public alert: RTEAlertService,
    @Inject(MAT_DIALOG_DATA) public data: Report) { }

  searchPublishedMenuStep: SaveStep = new SaveStep();
  searchSharedMenuStep: SaveStep = new SaveStep();
  removePermissionsPublishedStep: SaveStep = new SaveStep();
  removePermissionsSharedStep: SaveStep = new SaveStep();
  deletePublishedMenuStep: SaveStep = new SaveStep();
  deletePublishedObjectStep: SaveStep = new SaveStep();
  deleteSharedMenuStep: SaveStep = new SaveStep();
  deleteSharedObjectStep: SaveStep = new SaveStep();
  createMenuStep: SaveStep = new SaveStep();

  STATUS_ENUM_WAITING = StepStatusEnum.Waiting;

  ngOnInit() {
    this.loadSteps();
    this.manageMenus();
  }

  loadSteps() {
    this.searchPublishedMenuStep.Description = 'Procurando por este relatório em menus publicados';
    this.searchPublishedMenuStep.Status = StepStatusEnum.Waiting;
    this.searchSharedMenuStep.Description = 'Procurando por este relatório em menus compartilhados';
    this.searchSharedMenuStep.Status = StepStatusEnum.Waiting;
    this.removePermissionsPublishedStep.Description = 'Removendo permissões de usuários para o menu compartilhado';
    this.removePermissionsPublishedStep.Status = StepStatusEnum.Waiting;
    this.removePermissionsSharedStep.Description = 'Removendo permissões de usuários para o menu publicado';
    this.removePermissionsSharedStep.Status = StepStatusEnum.Waiting;
    this.deletePublishedMenuStep.Description = 'Excluindo menu publicado';
    this.deletePublishedMenuStep.Status = StepStatusEnum.Waiting;
    this.deletePublishedObjectStep.Description = 'Excluindo objeto publicado';
    this.deletePublishedObjectStep.Status = StepStatusEnum.Waiting;
    this.deleteSharedMenuStep.Description = 'Excluindo menu compartilhado';
    this.deleteSharedMenuStep.Status = StepStatusEnum.Waiting;
    this.deleteSharedObjectStep.Description = 'Excluindo objeto compartilhado';
    this.deleteSharedObjectStep.Status = StepStatusEnum.Waiting;
    this.createMenuStep.Description = 'Salvando alterações do relatório e criando objetos do novo menu';
    this.createMenuStep.Status = StepStatusEnum.Waiting;
  }

  getIconColor(step: SaveStep): string {
    switch (step.Status) {
      case StepStatusEnum.Success:
        return 'green';
      case StepStatusEnum.Error:
        return 'red';
      case StepStatusEnum.Skiped:
        return 'blue';
      default:
        return 'black';
    }
  }

  searchMenu(userPermissionReport: UserPermissionReport[]) {
    if (userPermissionReport) {
      if (userPermissionReport.length > 0 && userPermissionReport[0].ObjectSharedId > 0) {
        return true;
      }
    } else {
      if (this.data.ObjectId > 0) {
        return true;
      }
    }
    return false;
  }

  manageMenus() {
    if (this.searchMenu(null)) {
      this.searchPublishedMenuStep.Status = StepStatusEnum.Success;
      this.userPermissionReportService.getUserPermissionByReport(this.data).subscribe(foundSharedMenu => {
        if (this.searchMenu(foundSharedMenu)) {
          this.searchSharedMenuStep.Status = StepStatusEnum.Success;
          this.userPermissionReportService.deleteByReport(this.data.Id).subscribe(sharedPermissionsRemoved => {
            if (sharedPermissionsRemoved) {
              this.removePermissionsSharedStep.Status = StepStatusEnum.Success;
              this.menuService.deleteMenuByObjectId(foundSharedMenu[0].ObjectSharedId).subscribe(deletedSharedMenu => {
                if (deletedSharedMenu) {
                  this.deleteSharedMenuStep.Status = StepStatusEnum.Success;
                  this.objectService.delete(foundSharedMenu[0].ObjectSharedId).subscribe(deletedSharedObject => {
                    if (deletedSharedObject) {
                      this.deleteSharedObjectStep.Status = StepStatusEnum.Success;
                      this.userPermissionReportService.deleteByReport(this.data.Id).subscribe(publishedPermissionsRemoved => {
                        if (publishedPermissionsRemoved) {
                          this.removePermissionsPublishedStep.Status = StepStatusEnum.Success;
                          this.menuService.deleteMenuByObjectId(foundSharedMenu[0].ObjectPublicId).subscribe(deletedPublishedMenu => {
                            if (deletedPublishedMenu) {
                              this.deletePublishedMenuStep.Status = StepStatusEnum.Success;
                              this.objectService.delete(foundSharedMenu[0].ObjectPublicId).subscribe(deletedPublishedObject => {
                                if (deletedPublishedObject) {
                                  this.deletePublishedObjectStep.Status = StepStatusEnum.Success;
                                  this.publishReport();
                                }
                              }, error => {
                                this.alert.error(
                                  'Atenção',
                                  'Falha ao excluir objeto publicado, favor entrar em contato com a TI.',
                                  { expanded: true }
                                );
                                this.deletePublishedObjectStep.Status = StepStatusEnum.Error;
                                this.createMenuStep.Status = StepStatusEnum.Error;
                                this.dialogRef.disableClose = false;
                              });
                            }
                          }, error => {
                            this.alert.error(
                              'Atenção',
                              'Falha ao excluir menu publicado, favor entrar em contato com a TI.',
                              { expanded: true }
                            );
                            this.deletePublishedMenuStep.Status = StepStatusEnum.Error;
                            this.deletePublishedObjectStep.Status = StepStatusEnum.Error;
                            this.createMenuStep.Status = StepStatusEnum.Error;
                            this.dialogRef.disableClose = false;
                          });
                        }
                      }, error => {
                        this.alert.error(
                          'Atenção',
                          'Falha ao remover permissões, favor entrar em contato com a TI.',
                          { expanded: true }
                        );
                        this.removePermissionsPublishedStep.Status = StepStatusEnum.Error;
                        this.deletePublishedMenuStep.Status = StepStatusEnum.Error;
                        this.deletePublishedObjectStep.Status = StepStatusEnum.Error;
                        this.createMenuStep.Status = StepStatusEnum.Error;
                        this.dialogRef.disableClose = false;
                      });
                    }
                  }, error => {
                    this.alert.error(
                      'Atenção',
                      'Falha ao excluir objeto compartilhado, favor entrar em contato com a TI.',
                      { expanded: true }
                    );
                    this.deleteSharedObjectStep.Status = StepStatusEnum.Error;
                    this.removePermissionsPublishedStep.Status = StepStatusEnum.Error;
                    this.deletePublishedMenuStep.Status = StepStatusEnum.Error;
                    this.deletePublishedObjectStep.Status = StepStatusEnum.Error;
                    this.createMenuStep.Status = StepStatusEnum.Error;
                    this.dialogRef.disableClose = false;
                  });
                }
              }, error => {
                this.alert.error(
                  'Atenção',
                  'Falha ao excluir menu compartilhado, favor entrar em contato com a TI.',
                  { expanded: true }
                );
                this.deleteSharedMenuStep.Status = StepStatusEnum.Error;
                this.deleteSharedObjectStep.Status = StepStatusEnum.Error;
                this.removePermissionsPublishedStep.Status = StepStatusEnum.Error;
                this.deletePublishedMenuStep.Status = StepStatusEnum.Error;
                this.deletePublishedObjectStep.Status = StepStatusEnum.Error;
                this.createMenuStep.Status = StepStatusEnum.Error;
                this.dialogRef.disableClose = false;
              });
            }
          }, error => {
            this.alert.error(
              'Atenção',
              'Falha ao remover permissões, favor entrar em contato com a TI.',
              { expanded: true }
            );
            this.removePermissionsSharedStep.Status = StepStatusEnum.Error;
            this.deleteSharedMenuStep.Status = StepStatusEnum.Error;
            this.deleteSharedObjectStep.Status = StepStatusEnum.Error;
            this.removePermissionsPublishedStep.Status = StepStatusEnum.Error;
            this.deletePublishedMenuStep.Status = StepStatusEnum.Error;
            this.deletePublishedObjectStep.Status = StepStatusEnum.Error;
            this.createMenuStep.Status = StepStatusEnum.Error;
            this.dialogRef.disableClose = false;
          });
        } else {
          this.searchSharedMenuStep.Status = StepStatusEnum.Success;
          this.removePermissionsSharedStep.Status = StepStatusEnum.Skiped;
          this.deleteSharedMenuStep.Status = StepStatusEnum.Skiped;
          this.deleteSharedObjectStep.Status = StepStatusEnum.Skiped;
          this.userPermissionReportService.deleteByReport(this.data.Id).subscribe(publishedPermissionsRemoved => {
            if (publishedPermissionsRemoved) {
              this.removePermissionsPublishedStep.Status = StepStatusEnum.Success;
              this.menuService.deleteMenuByObjectId(this.data.ObjectId).subscribe(deletedPublishedMenu => {
                if (deletedPublishedMenu) {
                  this.deletePublishedMenuStep.Status = StepStatusEnum.Success;
                  this.objectService.delete(this.data.ObjectId).subscribe(deletedPublishedObject => {
                    if (deletedPublishedObject) {
                      this.deletePublishedObjectStep.Status = StepStatusEnum.Success;
                      this.publishReport();
                    }
                  }, error => {
                    this.alert.error(
                      'Atenção',
                      'Falha ao excluir objeto publicado, favor entrar em contato com a TI.',
                      { expanded: true }
                    );
                    this.deletePublishedObjectStep.Status = StepStatusEnum.Error;
                    this.createMenuStep.Status = StepStatusEnum.Error;
                    this.dialogRef.disableClose = false;
                  });
                }
              }, error => {
                this.alert.error(
                  'Atenção',
                  'Falha ao excluir menu publicado, favor entrar em contato com a TI.',
                  { expanded: true }
                );
                this.deletePublishedMenuStep.Status = StepStatusEnum.Error;
                this.deletePublishedObjectStep.Status = StepStatusEnum.Error;
                this.createMenuStep.Status = StepStatusEnum.Error;
                this.dialogRef.disableClose = false;
              });
            }
          }, error => {
            this.alert.error(
              'Atenção',
              'Falha ao remover permissões, favor entrar em contato com a TI.',
              { expanded: true }
            );
            this.removePermissionsPublishedStep.Status = StepStatusEnum.Error;
            this.deletePublishedMenuStep.Status = StepStatusEnum.Error;
            this.deletePublishedObjectStep.Status = StepStatusEnum.Error;
            this.createMenuStep.Status = StepStatusEnum.Error;
            this.dialogRef.disableClose = false;
          });
        }
      }, error => {
        this.alert.error(
          'Atenção',
          'Falha ao buscar menus compartilhados, favor entrar em contato com a TI.',
          { expanded: true }
        );
        this.searchPublishedMenuStep.Status = StepStatusEnum.Error;
        this.removePermissionsPublishedStep.Status = StepStatusEnum.Error;
        this.deletePublishedMenuStep.Status = StepStatusEnum.Error;
        this.deletePublishedObjectStep.Status = StepStatusEnum.Error;
        this.createMenuStep.Status = StepStatusEnum.Error;
        this.dialogRef.disableClose = false;
      });
    } else {
      this.searchPublishedMenuStep.Status = StepStatusEnum.Success;
      this.searchSharedMenuStep.Status = StepStatusEnum.Skiped;
      this.removePermissionsSharedStep.Status = StepStatusEnum.Skiped;
      this.removePermissionsPublishedStep.Status = StepStatusEnum.Skiped;
      this.deletePublishedMenuStep.Status = StepStatusEnum.Skiped;
      this.deletePublishedObjectStep.Status = StepStatusEnum.Skiped;
      this.deleteSharedMenuStep.Status = StepStatusEnum.Skiped;
      this.deleteSharedObjectStep.Status = StepStatusEnum.Skiped;
      this.publishReport();
    }
  }

  publishReport() {
    this.reportService.publishMenuUpdateReport(this.data).subscribe(published => {
      if (published) {
        this.createMenuStep.Status = StepStatusEnum.Success;
        this.dialogRef.disableClose = false;
      }
    }, error => {
      this.alert.error(
        'Atenção',
        'Falha ao criar menu, favor entrar em contato com a TI.',
        { expanded: true }
      );
      this.createMenuStep.Status = StepStatusEnum.Error;
      this.dialogRef.disableClose = false;
    });
  }
}
